<template>
  <div
    class="mt-2 sm:mt-6 px-4 py-5 flex flex-col items-center justify-center relative"
  >
    <!-- <spinner :busy="loading" color="#000" class="mt-12"></spinner> -->

    <!-- <div class="flex space-x-5">
      <button @click="test(0, 0, 0)" class="mt-4 mb-4">0.0</button>
      <button @click="test(0, 3, 4)" class="mt-4 mb-4">3.4</button>
      <button @click="test(0, 5, 5)" class="mt-4 mb-4">5.5</button>
      <button @click="test(0, 5, 7)" class="mt-4 mb-4">5.7</button>
      <button @click="test(1, 0, 0)" class="mt-4 mb-4">10</button>
    </div> -->

    <div class="h-fit flex items-center justify-center space-x-0">
      <transition name="slide-flip" mode="out-in">
        <div
          v-if="average.tenner"
          :key="average.tenner"
          class="font-mono text-8xl sm:text-[12rem] text-markencode-blue"
          :class="average.tenner > 0 ? 'visible' : 'invisible'">
          {{ average.tenner }}
        </div>
      </transition>

      <transition name="slide-flip" mode="out-in">
        <div
          :key="average.one"
          class="font-mono text-8xl sm:text-[12rem] text-markencode-blue"
        >
          {{ average.one }}
        </div>
      </transition>

      <div class="text-8xl sm:[12rem] text-markencode-blue">{{ divider }}</div>

      <transition name="slide-flip" mode="out-in">
        <div
          :key="average.decimal"
          class="font-mono text-8xl sm:text-[12rem] text-markencode-blue"
        >
          {{ average.decimal }}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Spinner from '@/Shared/Spinner';

export default {
  name: 'LiveResultsRating',

  metaInfo() {
    return {
      title: `Live Results`,
    };
  },

  components: {
    Spinner,
  },

  props: ['session', 'translations'],

  data() {
    return {
      loading: false,
      average: {
        tenner: 0,
        one: 0,
        decimal: 0,
      },
      refreshIntervalId: null,
    };
  },

  mounted() {
    Echo.channel('markencode-app.session.' + this.session.id).listen(
      '.participant.answered',
      (e) => {
        this.load();
      }
    );

    this.load();

    this.refreshIntervalId = window.setInterval(() => {
      this.load();
    }, 10000);
  },

  destroyed() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = null;
    }
  },

  methods: {
    load() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      window.axios
        .post(
          this.route('live-results.average', {
            id: this.session.uuid,
          }),
          {}
        )
        .then((response) => {
          this.convert(response.data.average);
          this.loading = false;
        })
        .catch((error) => {
          console.warn('live-results.rating.load failed', error?.response?.status, error?.message);
          this.loading = false;
        });
    },

    convert(average) {
      if(average === null) {
        average = 0;
      }

      let averageFormatted = average.toLocaleString('en-US', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });

      this.average.tenner =
        averageFormatted.length == 4 ? averageFormatted.substr(0, 1) : 0;

      this.average.one =
        averageFormatted.length == 4
          ? averageFormatted.substr(1, 1)
          : averageFormatted.substr(0, 1);

      this.average.decimal = averageFormatted.substr(-1);
    },

    test(tenner, one, decimal) {
      this.average.tenner = tenner;
      this.average.one = one;
      this.average.decimal = decimal;
    },
  },

  computed: {
    divider() {
      if (this.session.language == 'en') {
        return '.';
      }

      return ',';
    },
    // averageFormatted() {
    //   let locale = 'de-DE';

    //   if (this.session.language == 'en') {
    //     locale = 'en-US';
    //   }

    //   return this.average.toLocaleString(locale, {
    //     minimumFractionDigits: 1,
    //     maximumFractionDigits: 1,
    //   });
    // },

    // tenner() {
    //   return this.averageFormatted.length == 4 ? this.averageFormatted.substr(0, 1) : '';
    // },

    // one() {
    //   return this.averageFormatted.length == 4 ? this.averageFormatted.substr(1, 1) : this.averageFormatted.substr(0, 1);
    // },

    // decimal() {
    //   return this.averageFormatted.substr(-1);
    // },
  },
};
</script>

<style>
.slide-flip-enter,
.slide-flip-leave-to {
  transform: translateY(-100px);
  transition: transform 200ms cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
</style>
